import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@amzn/storm-ui';
import { selectSpoofingInfo, SpoofingInfo } from '../../store/slice';
import { RootState } from 'src/app/store';
import { HeaderLinkWrapper } from '../styles';
import {
  spoofingQueryParamName,
  quitSpoofingQueryParamValue,
} from 'src/commons/constants';

export const SpoofingInfoComponent: React.VFC<{
  spoofingInfo: SpoofingInfo;
}> = ({ spoofingInfo }) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(spoofingQueryParamName, quitSpoofingQueryParamValue);
  const quitSpoofingUrl =
    window.location.pathname + '?' + queryParams.toString();

  return (
    <HeaderLinkWrapper>
      <Link href={quitSpoofingUrl} data-ccx-e2e-id="aac-quit-spoofing">
        {spoofingInfo.quitButton.label}
      </Link>
    </HeaderLinkWrapper>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    spoofingInfo: selectSpoofingInfo(state),
  };
};

export default connect(mapStateToProps)(SpoofingInfoComponent);
